var FuseWidgetModule = /** @class */ (function () {
    function FuseWidgetModule() {
    }
    return FuseWidgetModule;
}());
export { FuseWidgetModule };
